import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';


const Checkout = () => {
    const handleCheckout = event => {
        event.preventDefault();
    }
    const [agree, setAgree] = useState(false);
    return (
        <section className='signup py-5'>
            <div className="container">
                <div className="row">
                    <div className="col-md-6 offset-md-3">
                        <div className="form-container">
                            <h2 className='text-success text-center mb-4'>Information</h2>
                            <Form onSubmit={handleCheckout}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Name</Form.Label>
                                    <Form.Control name='name' type="text" placeholder="Enter your name" required />
                                </Form.Group>

                                <Form.Group className="mb-3" >
                                    <Form.Label>Contact Number</Form.Label>
                                    <Form.Control name='number' type="text" placeholder="Enter contact number" />
                                </Form.Group>

                                <Form.Group className="mb-3" >
                                    <Form.Label>Address</Form.Label>
                                    <Form.Control name='adress' type="text" placeholder="Enter current address" required />
                                </Form.Group>

                                <Form.Group className="mb-3" >
                                    <Form.Label>Email address</Form.Label>
                                    <Form.Control name='email' type="email" placeholder="Enter email address" required />
                                </Form.Group>

                                <Form.Group className="mb-3" >
                                    <Form.Label>Password</Form.Label>
                                    <Form.Control name='password' type="password" placeholder="Password" required />
                                </Form.Group>

                                <Form.Group className="mb-3" >
                                    <Form.Label>Confirm Password</Form.Label>
                                    <Form.Control name='confirmPassword' type="password" placeholder="Retype your Password" required />

                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Check name='agree' onClick={() => setAgree(!agree)} type="checkbox" label="Agree with terms and conditions" />
                                </Form.Group>

                                <Button disabled={!agree} variant="primary" className='w-md-50' type="submit">
                                    Checkout Processed
                                </Button>
                            </Form>

                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Checkout;